// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c4fedef9","455":"2e783769"}[chunkId] + ".chunk.js";
};